// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper[data-v-6051236c] {\n  padding: 0 30px;\n}\n@media (max-width: 767.9px) {\n.wrapper[data-v-6051236c] {\n      padding: 0 20px;\n}\n}\n.tabs[data-v-6051236c] {\n  margin: 24px 0 40px;\n}\n[data-v-6051236c] .sidesheet__header {\n  display: none;\n}\n[data-v-6051236c] .sidesheet__wrapper {\n  padding: 0;\n}\n[data-v-6051236c] .c-tabs-shadow {\n  left: -29px;\n}\n", ""]);
// Exports
module.exports = exports;
